module.exports = require("lodash/isDate");